
export default {
  //用户信息 openid who等等
  userInfo:{
    // openid:'85oi0gLjwVuTbARN09HTv_Q-ptaKXM29-4',
    // openid: "44ooFDps40R4PsJZY1RRPK9eb2_pdk38-4",
    // openid: "44ooFDps6T1_N171i_5SFpnEL3kSJ438-4",
    openid: "969oT89156ue9pl5XInS9w_ue60uarU44-5",
    // openid:'3900FDps40R4PSJZY1RRPK9eb2_pdk5-3',
    // openid: "",
    code: "",
    examinetype: "",
    dayReportMintime: "",
    endtime: "",
    tel: "",
    judgedState: "",
    who: "",
  },
  //微信提供的信息
  weixinCodeInfo:{
    code:"",
    state:1,
    type:''
  },
  path: "",
}
